const USER_NAME = 'user';

export const setAuthUser = user =>
  localStorage.setItem(USER_NAME, JSON.stringify(user));
export const getAuthUser = () => JSON.parse(localStorage.getItem(USER_NAME));
export const delAuthUser = () => localStorage.removeItem(USER_NAME);
